import { SERVICE_DETAIL_ITEM_TYPE } from "../consts/serviceTemplate";

export const getServiceNameWithNewLine = (serviceName: string): string => {
  const replaced = applySpecificReplacements(serviceName);
  return serviceName === replaced
    ? serviceName.length > 5
      ? serviceName.replace(/(^[^\s]+)(\s)/, "$1\n")
      : serviceName
    : replaced;
};

function applySpecificReplacements(str: string): string {
  let replacementsArray: Array<[string, string]> = [
    [" 대여하기", "\n대여하기"],
    [" 모니터링", "\n모니터링"],
    [" 빈칸", "\n빈칸"],
    ["(10월", "\n(10월"],
    [" 개선", "\n개선"],
    ["강서사옥 ", "강서사옥\n"],
    [" 신청안내", "\n신청안내"],
    [" 잔액 조회", "\n잔액 조회"],
    [" 방문자 예약", "\n방문자 예약"],
    [" 신청하기", "\n신청하기"],
    ["신고 관리", "신고\n관리"],
    [" 통근", "\n통근"],
    [" (테스트)", "\n(테스트)"],
  ];

  if (window.innerWidth < 340) {
    replacementsArray = replacementsArray.concat([
      ["주제원신청", "주제원\n신청"],
      ["지원포탈", "지원\n포탈"],
      ["보드신청", "보드\n신청"],
      ["공간 예약하기", "공간\n예약하기"],
      ["해외출장", "해외출장\n"],
    ]);
  }

  for (const [pattern, replacement] of replacementsArray) {
    str = str?.replace(pattern, replacement);
  }

  return str;
}

export const replaceMemberShipName = (serviceDetailType?: string) => {
  if (serviceDetailType === SERVICE_DETAIL_ITEM_TYPE.SMART_OLIVE) {
    return "올리브식권 잔액";
  }
  return "사원카드 잔액"; // our-home
};

export const safeReplaceAll = (
  str?: string | null,
  search?: string,
  replacement?: string
) => {
  if (!str) return undefined;
  if (!search) return str;
  if (!replacement) return str;

  if (typeof str.replaceAll === "function") {
    return str.replaceAll(search, replacement);
  } else {
    return str.replace(
      new RegExp(search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
      replacement
    );
  }
};
